"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScaleUnitControls = void 0;
const pubsub_js_1 = require("pubsub-js");
const UiElements_1 = require("../../ui/UiElements");
class ScaleUnitControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (scaleUnit) is undefined");
        }
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        delete this.unitSelect;
    }
    refreshUI() {
        var _a, _b;
        const unit = (_a = this.unitSelect) === null || _a === void 0 ? void 0 : _a.getValue();
        let transformatorType = {
            transformatorConversionType: 6 /* TO_METER */,
            unit: "m"
        };
        switch (unit) {
            case "M" /* M */:
                transformatorType.transformatorConversionType = 6 /* TO_METER */;
                transformatorType.unit = "m";
                break;
            case "MM" /* MM */:
                transformatorType.transformatorConversionType = 9 /* TO_MILI */;
                transformatorType.unit = "mm";
                break;
            case "CM" /* CM */:
                transformatorType.transformatorConversionType = 8 /* TO_CENTI */;
                transformatorType.unit = "cm";
                break;
            case "DM" /* DM */:
                transformatorType.transformatorConversionType = 7 /* TO_DECI */;
                transformatorType.unit = "dm";
                break;
            case "KM" /* KM */:
                transformatorType.transformatorConversionType = 5 /* TO_KILO */;
                transformatorType.unit = "km";
                break;
            case "IN" /* IN */:
                transformatorType.transformatorConversionType = 1 /* TO_INCH */;
                transformatorType.unit = "in";
                break;
            case "FT" /* FT */:
                transformatorType.transformatorConversionType = 2 /* TO_FEET */;
                transformatorType.unit = "ft";
                break;
            case "YD" /* YD */:
                transformatorType.transformatorConversionType = 3 /* TO_YARD */;
                transformatorType.unit = "yd";
                break;
            case "MI" /* MI */:
                transformatorType.transformatorConversionType = 4 /* TO_MILE */;
                transformatorType.unit = "mi";
                break;
            default:
                console.error("Transformator type incorect, provided", unit);
                break;
        }
        (0, pubsub_js_1.publish)("change-measurement-type" /* CHANGE_MEASUREMENT_TYPE */, transformatorType);
        for (const option of (_b = this.unitSelect) === null || _b === void 0 ? void 0 : _b.domEl.children) {
            option.removeAttribute('selected');
            if (option.value === unit) {
                option.setAttribute('selected', '');
            }
        }
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('scaleUnitTitle')
            .addAttribute('data-i18n-key', 'UNIT');
    }
    createElement() {
        this.unitSelect = this.createSelectElement('unitSelect');
        const unitDiv = this.createElementDiv('unitSelect', this.unitSelect, 'UNIT');
        return new UiElements_1.DivEl()
            .setId('scaleUnitControls')
            .addChild(unitDiv);
    }
    createSelectElement(id) {
        return new UiElements_1.SelectEl()
            .setValue("M" /* M */)
            .setOptions({
            'M': 'METER',
            'MM': 'MILI_METER',
            'CM': 'CENTI_METER',
            'DM': 'DECI_METER',
            'KM': 'KILO_METER',
            'IN': 'INCH',
            'FT': 'FOOT',
            'YD': 'YARD',
            'MI': 'MILE'
        }, "M" /* M */)
            .setId(id);
    }
    createElementDiv(id, element, name) {
        return new UiElements_1.DivEl().addChild(element);
    }
}
exports.ScaleUnitControls = ScaleUnitControls;
